<template>
   <div id="app" v-if="webLoaded">
      <RakutenLayout :isWatchStreamPage="isWatchStreamPage">
         <router-view :id="routerKey" :key="routerKey" class="view-route-partial" @go-to-login="goToRakutenLogin" />
      </RakutenLayout>

      <b-modal
         id="confirm-modal"
         dialog-class="confirm-modal"
         content-class="confirm-modal__content"
         body-class="confirm-modal__body"
         footer-class="confirm-modal__footer"
         hide-header
         hide-footer
         centered
         no-close-on-backdrop
         no-close-on-esc
         size="sm"
      >
         <template v-slot:default>
            <h4 class="text-center font-weight-bold mt-4">ログイン</h4>
            <div class="text-center my-2 p-4">
               <p class="mb-0">この機能を利用するためには</p>
               <p>ログインが必要です</p>
            </div>
            <div class="row mx-3" style="margin-bottom:2rem">
               <div class="col-6">
                  <button class="btn btn-outline-pink custom-btn custom-btn-sm custom-btn--outline" @click="closeModal">閉じる</button>
               </div>
               <div class="col-6">
                  <button class="btn btn-pink custom-btn custom-btn-sm" @click="goToRakutenLogin">ログイン</button>
               </div>
            </div>
         </template>
      </b-modal>
   </div>
</template>

<script>
import { MOBILE_OS, STATUS_RESPONSES } from "./configs/SDK";
import { mapGetters } from "vuex";
import SdkMixins from "./mixins/SdkMixins";
import HelperMixins from "./mixins/HelperMixins";
import RakutenLayout from "@/layouts/RakutenLayout";
import { RAKUTEN_LOGIN_URL } from "./configs/Settings";
import { STATUS_MESSAGES, SYSTEM_MESSAGES } from "./messages/System";

export default {
   name: "App",
   components: { RakutenLayout },
   mixins: [SdkMixins, HelperMixins],
   data() {
      return {
         keyRouter: 0,
         viewerUsingMobileOS: MOBILE_OS.UN_KNOWN,
         loginURL: RAKUTEN_LOGIN_URL,
         webLoaded: false
      };
   },
   watch: {},
   computed: {
      ...mapGetters(["user", "channelStream"]),
      isWatchStreamPage() {
         return ["WatchStream", "LandingPage", "LoginPage"].some((x) => x === this.$route.name);
      },
      isMobileLayout: function() {
         if (this.isMobileLayoutSize) {
            this.$store.dispatch("updateMobileBrowserLayout", true);
            return true;
         } else {
            this.$store.dispatch("updateMobileBrowserLayout", false);
            return false;
         }
      },
      routerKey() {
         return `${this.$route.name}-${this.user.userInfo?.userId || this.user.guestId}`;
      }
   },
   created() {
      window.addEventListener("resize", this.onResize);
   },
   mounted() {
      this.init();
   },
   methods: {
      async init() {
         this.onResize();
         this.initAxiosInterceptor();
         await Promise.all([this.checkIsLoggedIn(), this.detectLocation()]);
         this.webLoaded = true;
      },
      initAxiosInterceptor() {
         this.$http.interceptors.response.use(
            (response) => {
               if (response.status === 200) {
                  if (response.data?.code && response.data.code !== STATUS_RESPONSES.SUCCESS) {
                     this.$toastr.e(response.data?.message || response.data?.Message, STATUS_MESSAGES.ERROR);
                  }
                  return response;
               } else {
                  this.$toastr.e(response.data?.message || response.data?.Message, STATUS_MESSAGES.ERROR);
                  return null;
               }
               //return response;
            },
            (error) => {
               // Any status codes that falls outside the range of 2xx cause this function to trigger
               // Do something with response error
               if (error?.response.status === 401) {
                  this.logout();
                  //this.guestLogin();
               } else {
                  this.$toastr.e(SYSTEM_MESSAGES.CONTACT_ADMIN, STATUS_MESSAGES.ERROR);
               }
               console.error(`AXIOS RESPONSE ERROR: ${error?.message}`);
               return Promise.reject(error);
            }
         );
      },
      closeModal() {
         if (this.$route.path === "/stream") this.$router.back();
         this.$bvModal.hide("confirm-modal");
      },
      goToRakutenLogin() {
         this.saveCurrentPageName();
         window.location.href = this.getLoginURL;
      }
   },
   beforeDestroy() {
      window.removeEventListener("resize", this.onResize);
   }
};
</script>

<style lang="scss">
@import "./assets/scss/style";
</style>
